export default __webpack_public_path__ + "static/media/About_IMG-Timing.d5e43fb1.png";